import { Tabs, Tab, Button } from "react-bootstrap"
import { useEffect, useState } from "react"
import ApplicantDetailModal from "./ApplicantDetailModal"
import { useDispatch, useSelector } from "react-redux"
import { ApplicationThreadedComments } from "./ThreadedCommentsModal"
import { Link } from "react-router-dom"
import BORModal from "./BORModal"
import InformationModal from "./InformationModal"
import { useNavigate } from "react-router-dom"
import { css } from "@emotion/react"
import ApplicationsRequiringAttention from "./ApplicationsRequiringAttention"
import AllApplications from "./AllApplications"
import { getAgencyById } from "../../../data/agencySlice"
import { getContact } from "../../../data/contactSlice"
import { getCurrentUser, getGaiUserByID } from "../../../data/authenticationSlice"
import Loader from "../../../components/Loader"
import ApplicationsOnBehalfOfAgencies from "./ApplicationsOnBehalfOfAgencies"

const componentStyle = css`
    p.note {
        color: #333;
        background: gold;
        font-size: 14px;
        margin: 12px 0 0 0;
    }
`

const Applications = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false)
    const [showComments, setShowComments] = useState(false)
    const [currentAppId, setCurrentAppId] = useState()
    const { fetchStatus: loadStatus } = useSelector((state) => state.agency)
    const [showBORModal, setShowBORModal] = useState(false)
    const [information, setShowInformation] = useState(false)
    const { fetchStatus } = useSelector((state) => state.contact)
    const handleCloseModal = () => {
        setShowModal(false)
        setCurrentAppId()
    }

    const handleOpenModal = (id) => {
        setShowModal(true)
        setCurrentAppId(id)
    }

    const handleComments = (appId) => {
        setCurrentAppId(appId)
        setShowComments(true)
    }

    const handleBORModal = (applicationId) => {
        setShowBORModal(true)
        setCurrentAppId(applicationId)
    }

    const handleInformationShow = (type, id) => {
        if (type === "Contact") {
            dispatch(getContact(id)).then(({ payload }) => {
                setShowInformation({
                    show: true,
                    informationType: type,
                    title: `${type} Information`,
                    data: {
                        firstName: payload?.item?.firstName,
                        lastName: payload?.item?.lastName,
                        email: payload?.item?.email,
                        phoneNumber: payload?.item?.phoneNumber,
                        producerCode: payload?.item?.producerCode,
                        nyftzProducerCode: payload?.item?.nyftzProducerCode,
                        active: payload?.item?.active
                    }
                })
            })
        } else {
            dispatch(getAgencyById(id)).then(({ payload }) => {
                setShowInformation({
                    show: true,
                    informationType: type,
                    title: `${type} Information`,
                    data: { ...payload }
                })
            })
        }
    }

    const handleNavigatorState = (id) => {
        navigate(`/admin/create-application`, { state: { applicationId: id } })
    }

    return (
        <div css={componentStyle}>
            <Loader show={fetchStatus === "loading" || loadStatus === "loading"} />

            <ApplicationThreadedComments
                show={showComments}
                hide={() => setShowComments(false)}
                currentAppId={currentAppId}
                hasAdminView={true}
            />
            {showBORModal && (
                <BORModal
                    show={showBORModal}
                    setShow={setShowBORModal}
                    applicationId={currentAppId}
                />
            )}
            {information.show && (
                <InformationModal
                    show={information.show}
                    setShow={() => setShowInformation({ show: false })}
                    information={information}
                />
            )}

            <div
                className="page-container gai-tabs"
                style={{ marginTop: "80px" }}>
                <div className="d-flex justify-content-end">
                    <Button
                        className="btn-sm"
                        variant="light"
                        onClick={() => navigate("/admin/create-application")}>
                        Create Application
                    </Button>
                </div>

                <Tabs
                    defaultActiveKey="attention"
                    id="applications-tabs">
                    <Tab
                        eventKey="attention"
                        title="Applications Requiring Attention">
                        <ApplicationsRequiringAttention
                            handleInformationShow={handleInformationShow}
                            handleOpenModal={handleOpenModal}
                            handleComments={handleComments}
                        />
                    </Tab>
                    <Tab
                        eventKey="all"
                        title="All Applications">
                        <AllApplications
                            handleInformationShow={handleInformationShow}
                            handleOpenModal={handleOpenModal}
                            handleComments={handleComments}
                            handleNavigatorState={handleNavigatorState}
                            handleBORModal={(appId) => handleBORModal(appId)}
                        />
                    </Tab>
                    <Tab
                        eventKey="onBehalf"
                        title="Application on Behalf of Agencies">
                        <ApplicationsOnBehalfOfAgencies
                            handleInformationShow={handleInformationShow}
                            handleOpenModal={handleOpenModal}
                            handleComments={handleComments}
                        />
                    </Tab>
                </Tabs>
                <ApplicantDetailModal
                    showModal={showModal}
                    applicationId={currentAppId}
                    handleCloseModal={handleCloseModal}
                />
            </div>
        </div>
    )
}

export default Applications
